// extracted by mini-css-extract-plugin
export default {"day":"Day_day__W+N-w","current":"Day_current__mtaP7","selected":"Day_selected__+CEFD"};